import { useState, useRef, useCallback } from "react";
import { createPortal } from "react-dom";

import CalendarEventCard from "@/components/desktop/list/calendar/CalendarEventCard";
import OAProductsTable from "../products/OAProductsTable";

const STATE_BORDER_COLORS = {
	1: "#7c3aed",
	2: "#82bc44",
	3: "#dc2626",
	4: "#d97706",
	5: "#2563eb",
	6: "#9ca3af",
};

const TOOLTIP_WIDTH = 680;

const OACalendarEventCard = ({ record, eventConfig }) => {
	const [tooltipVisible, setTooltipVisible] = useState(false);
	const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });
	const wrapperRef = useRef(null);

	const borderLeftColor = STATE_BORDER_COLORS[record?.application_orders_state_id] ?? "#82bc44";

	const handleMouseEnter = useCallback(() => {
		if (!record?.details?.length) return;
		if (!wrapperRef.current) return;

		const rect = wrapperRef.current.getBoundingClientRect();
		const spaceBelow = window.innerHeight - rect.bottom - 8;
		const top = spaceBelow > 200 ? rect.bottom + 6 : rect.top - 300;
		const left = Math.min(rect.left, window.innerWidth - TOOLTIP_WIDTH - 8);

		setTooltipPosition({ top, left });
		setTooltipVisible(true);
	}, [record?.details]);

	const handleMouseLeave = useCallback(() => {
		setTooltipVisible(false);
	}, []);

	return (
		<div ref={wrapperRef} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
			<CalendarEventCard record={record} eventConfig={eventConfig} borderLeftColor={borderLeftColor} />
			{tooltipVisible &&
				record?.details?.length > 0 &&
				createPortal(
					<div
						style={{
							position: "fixed",
							top: tooltipPosition.top,
							left: tooltipPosition.left,
							width: TOOLTIP_WIDTH,
							zIndex: 9999,
							pointerEvents: "none",
							boxShadow: "0 8px 24px rgba(15,23,42,0.12)",
						}}
					>
						<OAProductsTable
							details={record.details}
							wetness={record.application_orders_machineries_wetness ?? 0}
							machinedLiters={record.application_orders_machineries_machined ?? 0}
							applicationOrderTypeId={record.application_order_type_id ?? 0}
						/>
					</div>,
					document.body,
				)}
		</div>
	);
};

export default OACalendarEventCard;
